import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, InputSignal, Signal, ViewEncapsulation } from '@angular/core';
import { MDIconComponent, MDToolTipDirective } from '@melodic-ui/components';
import { IUserImageState, UserIconService } from './user-icon.service';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';

@Component({
	selector: 'lb-user-icon',
	imports: [CommonModule, MDIconComponent, MDToolTipDirective],
	standalone: true,
	templateUrl: './user-icon.component.html',
	styleUrl: './user-icon.component.scss',
	encapsulation: ViewEncapsulation.None
})
export class UserIconComponent {
	private _userIconService: UserIconService = inject(UserIconService);

	public defaultImageUrl: string = 'untitled-ui/users/user-circle';

	public userID: InputSignal<number | null | undefined> = input<number | null | undefined>();
	public isImpersonating: InputSignal<boolean> = input<boolean>(false);

	public userImageUrlState: Signal<{ [userID: number]: IUserImageState }> = this._userIconService.userImageUrlState;

	constructor() {
		toObservable(this.userID)
			.pipe(takeUntilDestroyed())
			.subscribe({
				next: (userID) => {
					if (userID !== undefined && userID !== null) {
						this._userIconService.loadUserImage(userID);
					}
				}
			});
	}

	public imageOrInitials: Signal<IUserImageState | undefined> = computed(() => {
		if (this.userID() === undefined) {
			return undefined;
		}

		return this.userImageUrlState()[this.userID() as number];
	});
}
